{
	"title": "Bundels",
	"kind": {
		"label": "Soort",
		"standard": "Gewoon product",
		"bundle": "Bundel (bestaat uit andere producten)"
	},
	"listBadge": "Bundel",
	"components": {
		"title": "Onderdelen",
		"description": "Een bundel bestaat uit varianten van andere producten. De prijs van de bundel stel je zelf in bij Basis.",
		"empty": "Deze bundel heeft nog geen onderdelen. Zoek hieronder een product om toe te voegen.",
		"column": {
			"name": "Onderdeel",
			"quantity": "Aantal",
			"available": "Beschikbaar",
			"price": "Losse prijs",
			"actions": "Acties"
		},
		"quantityOf": "Aantal van {{name}}",
		"remove": "{{name}} uit de bundel halen",
		"inactive": "Niet te koop",
		"priceEach": "{{price}} per stuk",
		"summary": "Losse prijzen samen: {{parts}}. Bundelprijs: {{bundle}}.",
		"cheaper": "Een koper bespaart {{amount}}.",
		"quantityInvalid": "Vul een aantal van 1 tot en met 999 in.",
		"notForSaleTitle": "Deze bundel is niet te koop",
		"notForSale_one": "{{names}} is inactief of verwijderd. Zet het weer aan of haal het uit de bundel; tot dan is de bundel niet te koop.",
		"notForSale_other": "{{names}} zijn inactief of verwijderd. Zet ze weer aan of haal ze uit de bundel; tot dan is de bundel niet te koop.",
		"inactivePrepacked_one": "{{names}} is inactief of verwijderd. Deze bundel is voorverpakt en blijft te koop op zijn eigen voorraad.",
		"inactivePrepacked_other": "{{names}} zijn inactief of verwijderd. Deze bundel is voorverpakt en blijft te koop op zijn eigen voorraad."
	},
	"add": {
		"label": "Onderdeel toevoegen",
		"placeholder": "Zoek op productnaam of SKU",
		"none": "Geen producten gevonden. Bundels kunnen geen onderdeel zijn.",
		"inBundle": "Zit er al in",
		"add": "Toevoegen"
	},
	"stockMode": {
		"label": "Voorraad",
		"composed": "Samengesteld",
		"composedDescription": "De voorraad volgt uit de onderdelen. Een verkoop boekt de onderdelen af.",
		"prepacked": "Voorverpakt",
		"prepackedDescription": "De bundel ligt kant-en-klaar in het magazijn en heeft eigen voorraad.",
		"available_one": "Nu {{count}} bundel beschikbaar.",
		"available_other": "Nu {{count}} bundels beschikbaar."
	},
	"error": {
		"notFound": "Deze bundel bestaat niet (meer).",
		"variantNotFound": "Deze variant bestaat niet (meer).",
		"nested": "Een bundel kan geen bundel bevatten.",
		"exists": "Deze variant zit al in de bundel. Pas het aantal aan.",
		"tooMany": "Een bundel heeft hoogstens 50 onderdelen.",
		"componentNotFound": "Dit onderdeel zit niet (meer) in de bundel.",
		"openReservations": "Er staan nog reserveringen open voor deze bundel. Wissel van voorraad als die zijn afgerond.",
		"hasStock": "Boek eerst de voorraad van deze bundel af. Een samengestelde bundel heeft geen eigen voorraad, dus die kun je daarna niet meer corrigeren.",
		"archived": "Deze bundel is gearchiveerd. Zet het product eerst terug om hem te wijzigen."
	},
	"help": {
		"components": {
			"title": "Bundel",
			"area": "Producten › Onderdelen",
			"short": "Een set van varianten van andere producten, zoals een startpakket met een wisser en doekjes. Je kiest de onderdelen en hoeveel van elk. De prijs van de bundel geef je zelf, bij Basis.",
			"warning": "Is een onderdeel niet te koop, dan is een samengestelde bundel dat ook niet.",
			"terms": ["bundle:stockMode", "product:kind"]
		},
		"stockMode": {
			"title": "Samengesteld of voorverpakt",
			"area": "Producten › Onderdelen",
			"short": "Hoe de voorraad van een bundel telt. Samengesteld als je hem pas bij een order inpakt, voorverpakt als hij kant-en-klaar in het magazijn ligt.",
			"choices": [
				{
					"name": "Samengesteld",
					"text": "Geen eigen voorraad, want hij ligt niet kant-en-klaar: er zijn zoveel bundels als de onderdelen toelaten. Een verkoop boekt de onderdelen af."
				},
				{
					"name": "Voorverpakt",
					"text": "Eigen voorraad, die je onder Voorraad boekt. Een verkoop boekt de bundel af, de onderdelen niet."
				}
			],
			"warning": "Een samengestelde bundel heeft geen eigen voorraad, dus je kunt er niets op boeken: boek op de onderdelen. Naar samengesteld kan pas als de eigen voorraad op 0 staat.",
			"terms": ["product:variantStock"]
		}
	}
}
